import { IAction } from 'src/typings';
import { ActionTypes } from 'src/store/placement/actions';
import { IPlacement } from 'src/typings/placement';

export const initialState: IPlacement | null = null;

export const placementReducer = (
  state = initialState,
  { type, payload }: IAction,
): IPlacement | null => {
  switch (type) {
    case ActionTypes.SET_PLACEMENT_DATA:
      return {
        ...(state ?? {}),
        ...payload,
      } as IPlacement;
    case ActionTypes.RESET_PLACEMENT_DATA:
      return initialState;
    default:
      return state;
  }
};
